import { SiteGeneratorBiEventNumbers } from '../consts';
import {
  CommonBiFn,
  FedopsInteraction,
  FedopsOptions,
  FullHomepageStructure,
  PageStructure,
  SectionPresetStructure,
} from '../types';
import { isHomepageStructure } from './siteGeneratorUtils';

export const collectPageStructures = (
  sections: SectionPresetStructure[],
  pageStructure: PageStructure | FullHomepageStructure,
) => {
  const structuresToInject = sections.map(({ structure }) => structure);

  if (isHomepageStructure(pageStructure)) {
    pageStructure.header?.structure &&
      structuresToInject.unshift(pageStructure.header.structure);
    pageStructure.footer?.structure &&
      structuresToInject.push(pageStructure.footer.structure);
  }

  return structuresToInject;
};

export const handleImageGenerationEvent =
  (
    interactionStarted: FedopsInteraction,
    interactionEnded: FedopsInteraction,
    createFedopsOptions: FedopsOptions,
    origin: string,
    siteCommonBi?: CommonBiFn,
  ) =>
  ({ type, payload }) => {
    const bundleBiData = {
      type: origin === 'homepage' ? 'mini version' : 'post injection variants',
      origin: 'ai',
    };
    switch (type) {
      case 'onSingleGenerationStart':
        interactionStarted(
          'sg_ai_image_injection',
          createFedopsOptions(payload),
        );
        break;
      case 'onSingleGenerationSuccess':
        interactionEnded('sg_ai_image_injection', createFedopsOptions(payload));
        siteCommonBi?.(SiteGeneratorBiEventNumbers.IMAGE_INJECTION_SUCCESS, {
          ...bundleBiData,
          ...payload,
        });
        break;
      case 'onTextOnImageGenerationEnd':
        interactionEnded(
          'sg_ai_textonimage_injection',
          createFedopsOptions(payload),
        );
        siteCommonBi?.(SiteGeneratorBiEventNumbers.IMAGE_INJECTION_SUCCESS, {
          ...bundleBiData,
          ...payload,
        });
        break;
      case 'onSingleGenerationError':
        siteCommonBi?.(SiteGeneratorBiEventNumbers.IMAGE_INJECTION_FAILED, {
          ...bundleBiData,
          ...payload,
        });
        break;
      case 'onBunchGenerationStart':
        interactionStarted(
          'sg_ai_image_injection_bundle',
          createFedopsOptions(payload),
        );
        break;
      case 'onBunchGenerationSuccess':
        interactionEnded(
          'sg_ai_image_injection_bundle',
          createFedopsOptions(payload),
        );
        break;
      default:
        break;
    }
  };

export const getSectionAiImageIndex = (
  index: number,
  pageStructure: PageStructure | FullHomepageStructure,
) =>
  isHomepageStructure(pageStructure) && pageStructure.header
    ? index + 1
    : index;
